import { DeviceWithVehicleInfo } from "@/models/DeviceWithVehicleInfo";

/**
 * The firmware a telematics unit is running, as one string.
 *
 * Only built when every part is known: a half-built version string reads like a real one, and
 * both places that show it are places someone signs a vehicle off from.
 *
 * @param device - The device. Note that MyGeotab only returns these fields when they were asked
 *   for explicitly, so a device fetched with a narrow property selector reports nothing here.
 */
export function getFirmwareValue(device: DeviceWithVehicleInfo | null | undefined): string {
  if (!device) {
    return "";
  }

  const { productId, major, minor, parameterVersion, parameterVersionOnDevice } = device;
  const parts: (string | number | undefined)[] = [
    productId,
    major,
    minor,
    parameterVersion,
    parameterVersionOnDevice,
  ];
  // An empty string is just as "missing" as null/undefined here -- MyGeotab can report
  // productId as "" rather than leaving it out, and that must not build a half-string either.
  if (parts.some(part => part == null || part === "")) {
    return "";
  }

  return `${productId}.${major}.${minor} param ${parameterVersion} paramOnDevice ${parameterVersionOnDevice}`;
}
